import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks';
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo";
import { CustomAccordion } from "../../../ui/molecules/accordion";
import { Calendar } from "../../../ui/molecules/calendar";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../ui/molecules/textArea/TextArea";
import { countries, fiscalRegimeOptions, genreSelect, OptionType, Province, Region, regions } from "../../../utils";
import { provinceComuniMap } from "../../../utils/listaComuni";
import {
    resetEditStatus,
    resetGetByIdStatus,
    setAddress,
    setBirthCity,
    setBirthDate,
    setBirthProvince,
    setBirthRegion,
    setCap,
    setCity,
    setCityRegister,
    setEnding,
    setExternalCity,
    setExternalNation,
    setExternalProvince,
    setFirstEmail,
    setFirstFax,
    setFirstHouse,
    setFirstOffice,
    setFirstPhone,
    setFiscalCode,
    setFiscalRegime,
    setIdCode,
    setName,
    setNote,
    setNumRegister,
    setNumScheda,
    setPec,
    setPMId,
    setProfessionalRegister,
    setProvince,
    setRegion,
    setSdi,
    setSecondEmail,
    setSecondFax,
    setSecondHouse,
    setSecondOffice,
    setSecondPhone,
    setSex,
    setStarting,
    setSurname,
    setVat
} from "./slice";

export function BoxAnagrafica() {
    const dispatch = useAppDispatch()
    const anagraficaState = useAppSelector(state => state.PMAnagrafica)
    const PMState = useAppSelector(state => state.personalManagement)

    const [expanded, setExpanded] = useState<string | false>("panel1");
    const [showAnagrafica, setAnagrafica] = useState<boolean>(false);

    const [provinceOptions, setProvinceOptions] = useState<OptionType[]>([]);
    const [comuneOptions, setComuneOptions] = useState<OptionType[]>([]);
    const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
    const [selectedProvince, setSelectedProvince] = useState<string | null>(null);

    const [provinceRPOptions, setProvinceRPOptions] = useState<OptionType[]>([]);
    const [comuneRPOptions, setComuneRPOptions] = useState<OptionType[]>([]);
    const [selectedRPRegion, setSelectedRPRegion] = useState<string | null>(null);
    const [selectedRPProvince, setSelectedRPProvince] = useState<string | null>(null);

    const handleToggleAccordion = (panel: string) => {
        setExpanded(expanded === panel ? false : panel);
    };

    const regionOptions: OptionType[] = regions.map((region: Region) => ({
        value: region.name,
        label: region.name
    }));

    useEffect(() => {
        dispatch(setPMId(PMState.currentPersonalManagementId?.toString()))
        if (PMState.currentPersonalManagementId) {
            setAnagrafica(true)
        }
    }, [])

    useEffect(() => {
        if (anagraficaState.AnagraphicEditStatus === 'successfully') {
            dispatch(resetEditStatus('idle'))
        }
    }, [anagraficaState.AnagraphicEditStatus])

    useEffect(() => {
        if (anagraficaState.GetByIdAnagraphicStatus === 'successfully') {
            if (anagraficaState.getByIdAnagraphicRequest) {
                if (anagraficaState.getByIdAnagraphicRequest.birthRegion) {
                    const foundRegion = regions.find((region: Region) => region.name === anagraficaState.getByIdAnagraphicRequest.birthRegion);
                    if (foundRegion) {
                        const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                            value: province.code,
                            label: province.name
                        }));
                        setProvinceOptions(newProvinceOptions);
                    } else {
                        setProvinceOptions([]);
                    }
                } else {
                    setProvinceOptions([]);
                }

                if (anagraficaState.getByIdAnagraphicRequest.region) {
                    const foundRegion = regions.find((region: Region) => region.name === anagraficaState.getByIdAnagraphicRequest.region);
                    if (foundRegion) {
                        const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                            value: province.code,
                            label: province.name
                        }));
                        setProvinceRPOptions(newProvinceOptions);
                    } else {
                        setProvinceRPOptions([]);
                    }
                } else {
                    setProvinceRPOptions([]);
                }

                if (anagraficaState.getByIdAnagraphicRequest?.birthProvince) {
                    const comuni = provinceComuniMap.get(anagraficaState.getByIdAnagraphicRequest?.birthProvince) || [];
                    const newComuneOptions = comuni.map((comune: string) => ({
                        value: comune,
                        label: comune
                    }));
                    setComuneOptions(newComuneOptions);
                } else {
                    setComuneOptions([]);
                }

                if (anagraficaState.getByIdAnagraphicRequest?.province) {
                    const comuni = provinceComuniMap.get(anagraficaState.getByIdAnagraphicRequest?.province) || [];
                    const newComuneOptions = comuni.map((comune: string) => ({
                        value: comune,
                        label: comune
                    }));
                    setComuneRPOptions(newComuneOptions);
                } else {
                    setComuneRPOptions([]);
                }

                dispatch(setNumScheda(anagraficaState.getByIdAnagraphicRequest.numScheda))
                dispatch(setIdCode(anagraficaState.getByIdAnagraphicRequest.identifierCode))
                dispatch(setName(anagraficaState.getByIdAnagraphicRequest.name))
                dispatch(setSurname(anagraficaState.getByIdAnagraphicRequest.surname))
                dispatch(setSurname(anagraficaState.getByIdAnagraphicRequest.surname))
                dispatch(setSex(anagraficaState.getByIdAnagraphicRequest.sex))
                dispatch(setBirthDate(anagraficaState.getByIdAnagraphicRequest.birth))
                dispatch(setBirthRegion(anagraficaState.getByIdAnagraphicRequest.birthRegion))
                dispatch(setBirthProvince(anagraficaState.getByIdAnagraphicRequest.birthProvince))
                dispatch(setBirthCity(anagraficaState.getByIdAnagraphicRequest.city))
                dispatch(setExternalNation(anagraficaState.getByIdAnagraphicRequest.externalNation))
                dispatch(setExternalProvince(anagraficaState.getByIdAnagraphicRequest.externalProvince))
                dispatch(setExternalCity(anagraficaState.getByIdAnagraphicRequest.externalCity))
                dispatch(setAddress(anagraficaState.getByIdAnagraphicRequest.address))
                dispatch(setRegion(anagraficaState.getByIdAnagraphicRequest.region))
                dispatch(setProvince(anagraficaState.getByIdAnagraphicRequest.province))
                dispatch(setCity(anagraficaState.getByIdAnagraphicRequest.city))
                dispatch(setFirstEmail(anagraficaState.getByIdAnagraphicRequest.firstEmail))
                dispatch(setSecondEmail(anagraficaState.getByIdAnagraphicRequest.secondEmail))
                dispatch(setPec(anagraficaState.getByIdAnagraphicRequest.pec))
                dispatch(setFirstHouse(anagraficaState.getByIdAnagraphicRequest.firstHouse))
                dispatch(setSecondHouse(anagraficaState.getByIdAnagraphicRequest.secondHouse))
                dispatch(setFirstOffice(anagraficaState.getByIdAnagraphicRequest.firstOffice))
                dispatch(setSecondOffice(anagraficaState.getByIdAnagraphicRequest.secondHouse))
                dispatch(setCityRegister(anagraficaState.getByIdAnagraphicRequest.cityRegister))
                dispatch(setFirstFax(anagraficaState.getByIdAnagraphicRequest.firstFax))
                dispatch(setFirstPhone(anagraficaState.getByIdAnagraphicRequest.firstPhone))
                dispatch(setFiscalCode(anagraficaState.getByIdAnagraphicRequest.fiscalCode))
                dispatch(setFiscalRegime(anagraficaState.getByIdAnagraphicRequest.fiscalRegime))
                dispatch(setNote(anagraficaState.getByIdAnagraphicRequest.note))
                dispatch(setNumRegister(anagraficaState.getByIdAnagraphicRequest.numRegister))
                dispatch(setProfessionalRegister(anagraficaState.getByIdAnagraphicRequest.professionalRegister))
                dispatch(setSdi(anagraficaState.getByIdAnagraphicRequest.sdi))
                dispatch(setSecondFax(anagraficaState.getByIdAnagraphicRequest.secondFax))
                dispatch(setSecondPhone(anagraficaState.getByIdAnagraphicRequest.secondPhone))
                dispatch(setStarting(anagraficaState.getByIdAnagraphicRequest.starting))
                dispatch(setEnding(anagraficaState.getByIdAnagraphicRequest.ending))
                dispatch(setVat(anagraficaState.getByIdAnagraphicRequest.vat))
                dispatch(setPMId(anagraficaState.getByIdAnagraphicRequest.personalManagementId.toString()))
                setAnagrafica(true)
            }
            dispatch(resetGetByIdStatus('idle'))
        }
    }, [anagraficaState.GetByIdAnagraphicStatus])

    useEffect(() => {
        if (selectedRegion) {
            const foundRegion = regions.find((region: Region) => region.name === selectedRegion);
            if (foundRegion) {
                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));
                setProvinceOptions(newProvinceOptions);
            } else {
                setProvinceOptions([]);
            }
        } else {
            setProvinceOptions([]);
        }
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedProvince) {
            const comuni = provinceComuniMap.get(selectedProvince) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setComuneOptions(newComuneOptions);
        } else {
            setComuneOptions([]);
        }
    }, [selectedProvince]);

    useEffect(() => {
        if (selectedRPRegion) {
            const foundRegion = regions.find((region: Region) => region.name === selectedRPRegion);
            if (foundRegion) {
                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));
                setProvinceRPOptions(newProvinceOptions);
            } else {
                setProvinceRPOptions([]);
            }
        } else {
            setProvinceRPOptions([]);
        }
    }, [selectedRPRegion]);

    useEffect(() => {
        if (selectedRPProvince) {
            const comuni = provinceComuniMap.get(selectedRPProvince) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setComuneRPOptions(newComuneOptions);
        } else {
            setComuneRPOptions([]);
        }
    }, [selectedRPProvince]);

    const selectToValue = (value: any) => {
        if (value === null || value === undefined) {
            return null;
        }
        return typeof value === 'string' ? value : value.value;
    };

    if (!showAnagrafica) {
        return <LogoSpinnerComponent fullScreen />
    }

    return (
        <div className="p-6 flex flex-col gap-6" id="boxAnagrafica">
            <CustomAccordion
                id="panel1"
                title={<span className="text-uppercase text-white label-input">Dati anagrafici</span>}
                expanded={expanded === 'panel1'}
                onChange={() => handleToggleAccordion('panel1')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-2 gap-4">
                    <MadfarmInput
                        label={'Scheda n.'}
                        placeholder="Specificare numero..."
                        error={anagraficaState.anagraphicErrors.numScheda}
                        supportingText={anagraficaState.anagraphicErrors.numScheda ? "Inserire Numero Scheda." : undefined}
                        value={anagraficaState.createAnagraphicRequest.numScheda}
                        defaultValue={anagraficaState.createAnagraphicRequest.numScheda}
                        onChangeText={(text) => { dispatch(setNumScheda(text)) }}
                    />
                    <MadfarmInput
                        label={'Codice identificativo del tecnico ispettore'}
                        placeholder="Specificare numero..."
                        value={anagraficaState.createAnagraphicRequest.identifierCode}
                        defaultValue={anagraficaState.createAnagraphicRequest.identifierCode}
                        onChangeText={(text) => { dispatch(setIdCode(text)) }}
                    />
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <MadfarmInput
                        label={'Cognome'}
                        placeholder="Cognome"
                        error={anagraficaState.anagraphicErrors.surname}
                        supportingText={anagraficaState.anagraphicErrors.surname ? "Inserire un cognome" : undefined}
                        value={anagraficaState.createAnagraphicRequest.surname}
                        defaultValue={anagraficaState.createAnagraphicRequest.surname}
                        onChangeText={(text) => { dispatch(setSurname(text)) }}
                    />
                    <MadfarmInput
                        label={'Nome'}
                        placeholder="Nome"
                        error={anagraficaState.anagraphicErrors.name}
                        supportingText={anagraficaState.anagraphicErrors.name ? "Inserire un nome." : undefined}
                        value={anagraficaState.createAnagraphicRequest.name}
                        defaultValue={anagraficaState.createAnagraphicRequest.name}
                        onChangeText={(text) => { dispatch(setName(text)) }}
                    />
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        label="Sesso"
                        placeholder={'Sesso'}
                        options={genreSelect}
                        value={anagraficaState.createAnagraphicRequest.sex}
                        defaultValue={anagraficaState.createAnagraphicRequest.sex}
                        error={anagraficaState.anagraphicErrors.sex}
                        errorLabel="Specificare sesso"
                        noOptionsMessage="Nessuna opzione trovata"
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setSex(selectToValue(newValue)))
                        }}
                    />
                    <Calendar
                        label="Data di nascita"
                        selected={anagraficaState.createAnagraphicRequest.birth}
                        onChange={(date) => {
                            dispatch(setBirthDate(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                </div>

                <div className="grid grid-cols-3 gap-4">
                    <MadfarmStaticSelect
                        label="Regione di nascita"
                        placeholder={'Regione'}
                        options={regionOptions}
                        value={anagraficaState.createAnagraphicRequest.birthRegion}
                        defaultValue={anagraficaState.createAnagraphicRequest.birthRegion}
                        error={anagraficaState.anagraphicErrors.birthRegion}
                        errorLabel="Inserire regione di nascita"
                        noOptionsMessage="Nessuna regione trovata"
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            const newValues = selectToValue(newValue)
                            setSelectedRegion(newValues)
                            setSelectedProvince(null)
                            dispatch(setBirthRegion(newValues))
                        }}
                    />
                    <MadfarmStaticSelect
                        label="Provincia di nascita"
                        placeholder={'Provincia'}
                        options={provinceOptions}
                        value={anagraficaState.createAnagraphicRequest.birthProvince}
                        defaultValue={anagraficaState.createAnagraphicRequest.birthProvince}
                        error={anagraficaState.anagraphicErrors.birthProvince}
                        errorLabel="Inserire provincia di nascita"
                        noOptionsMessage="Nessuna provincia trovata"
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            const newValues = selectToValue(newValue)
                            setSelectedProvince(newValues)
                            dispatch(setBirthProvince(newValues))
                        }}
                    />
                    <MadfarmStaticSelect
                        label="Comune di nascita"
                        placeholder={'Comune'}
                        options={comuneOptions}
                        value={anagraficaState.createAnagraphicRequest.birthCity}
                        defaultValue={anagraficaState.createAnagraphicRequest.birthCity}
                        error={anagraficaState.anagraphicErrors.birthCity}
                        errorLabel="Inserire comune di nascita"
                        noOptionsMessage="Nessun comune trovato"
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setBirthCity(selectToValue(newValue)))
                        }}
                    />
                </div>

                <div className="text-left">
                    <span className="text-sm font-medium text-red-500">Nel caso in cui l'utente e nato in uno stato straniero</span>
                </div>

                <div className="grid grid-cols-3 gap-4">
                    <MadfarmStaticSelect
                        label="Nazione di nascita"
                        placeholder={'Nazione'}
                        options={countries}
                        value={anagraficaState.createAnagraphicRequest.externalNation}
                        defaultValue={anagraficaState.createAnagraphicRequest.externalNation}
                        noOptionsMessage="Nessuna nazione trovata"
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setExternalNation(selectToValue(newValue)))
                        }}
                    />
                    <MadfarmInput
                        label={'Provincia'}
                        placeholder="Provincia"
                        value={anagraficaState.createAnagraphicRequest.externalProvince}
                        defaultValue={anagraficaState.createAnagraphicRequest.externalProvince}
                        onChangeText={(text) => { dispatch(setExternalProvince(text)) }}
                    />
                    <MadfarmInput
                        label={'Comune'}
                        placeholder="Comune"
                        value={anagraficaState.createAnagraphicRequest.externalCity}
                        defaultValue={anagraficaState.createAnagraphicRequest.externalCity}
                        onChangeText={(text) => { dispatch(setExternalCity(text)) }}
                    />
                </div>
            </CustomAccordion>

            <CustomAccordion
                id="panel2"
                title={<span className="text-uppercase text-white label-input">Recapiti</span>}
                expanded={expanded === 'panel2'}
                onChange={() => handleToggleAccordion('panel2')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-4 gap-4">
                    <MadfarmStaticSelect
                        label="Regione"
                        placeholder={'Regione'}
                        options={regionOptions}
                        value={anagraficaState.createAnagraphicRequest.region}
                        defaultValue={anagraficaState.createAnagraphicRequest.region}
                        noOptionsMessage="Nessuna regione trovata"
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            const newValues = selectToValue(newValue)
                            setSelectedRPRegion(newValues)
                            setSelectedRPProvince(null)
                            dispatch(setRegion(newValues))
                        }}
                    />
                    <MadfarmStaticSelect
                        label="Provincia"
                        placeholder={'Provincia'}
                        options={provinceRPOptions}
                        value={anagraficaState.createAnagraphicRequest.province}
                        defaultValue={anagraficaState.createAnagraphicRequest.province}
                        noOptionsMessage="Nessuna provincia trovata"
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            const newValues = selectToValue(newValue)
                            setSelectedRPProvince(newValues)
                            dispatch(setProvince(newValues))
                        }}
                    />
                    <MadfarmStaticSelect
                        label="Comune"
                        placeholder={'Comune'}
                        options={comuneRPOptions}
                        value={anagraficaState.createAnagraphicRequest.city}
                        defaultValue={anagraficaState.createAnagraphicRequest.city}
                        noOptionsMessage="Nessun comune trovato"
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setCity(selectToValue(newValue)))
                        }}
                    />
                    <MadfarmInput
                        label={'Cap'}
                        placeholder="Cap"
                        value={anagraficaState.createAnagraphicRequest.cap}
                        defaultValue={anagraficaState.createAnagraphicRequest.cap}
                        onChangeText={(text) => { dispatch(setCap(text)) }}
                    />
                </div>
                <div className="grid grid-cols-1 gap-4">
                    <MadfarmInput
                        label={'Indirizzo'}
                        placeholder="Indirizzo"
                        value={anagraficaState.createAnagraphicRequest.address}
                        defaultValue={anagraficaState.createAnagraphicRequest.address}
                        onChangeText={(text) => { dispatch(setAddress(text)) }}
                    />
                </div>
            </CustomAccordion>

            <CustomAccordion
                id="panel4"
                title={<span className="text-uppercase text-white label-input">Rubrica</span>}
                expanded={expanded === 'panel4'}
                onChange={() => handleToggleAccordion('panel4')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-2 gap-4">
                    <MadfarmInput label={'Telefono Abitazione 1'} placeholder="Telefono Abitazione 1" value={anagraficaState.createAnagraphicRequest.firstHouse} defaultValue={anagraficaState.createAnagraphicRequest.firstHouse} onChangeText={(text) => { dispatch(setFirstHouse(text)) }} />
                    <MadfarmInput label={'Telefono Abitazione 2'} placeholder='Telefono Abitazione 2' value={anagraficaState.createAnagraphicRequest.secondHouse} defaultValue={anagraficaState.createAnagraphicRequest.secondHouse} onChangeText={(text) => { dispatch(setSecondHouse(text)) }} />
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <MadfarmInput label={'Telefono Ufficio 1'} placeholder="Telefono Ufficio 1" value={anagraficaState.createAnagraphicRequest.firstOffice} defaultValue={anagraficaState.createAnagraphicRequest.firstOffice} onChangeText={(text) => { dispatch(setFirstOffice(text)) }} />
                    <MadfarmInput label={'Telefono Ufficio 2'} placeholder='Telefono Ufficio 2' value={anagraficaState.createAnagraphicRequest.secondOffice} defaultValue={anagraficaState.createAnagraphicRequest.secondOffice} onChangeText={(text) => { dispatch(setSecondOffice(text)) }} />
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <MadfarmInput label={'Fax 1'} placeholder="Fax 1" value={anagraficaState.createAnagraphicRequest.firstFax} defaultValue={anagraficaState.createAnagraphicRequest.firstFax} onChangeText={(text) => { dispatch(setFirstFax(text)) }} />
                    <MadfarmInput label={'Fax 2'} placeholder='Fax 2' value={anagraficaState.createAnagraphicRequest.secondFax} defaultValue={anagraficaState.createAnagraphicRequest.secondFax} onChangeText={(text) => { dispatch(setSecondFax(text)) }} />
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <MadfarmInput
                        label={'Cellulare 1'}
                        placeholder="Cellulare 1"
                        value={anagraficaState.createAnagraphicRequest.firstPhone}
                        defaultValue={anagraficaState.createAnagraphicRequest.firstPhone}
                        error={anagraficaState.anagraphicErrors.firstPhone}
                        supportingText={anagraficaState.anagraphicErrors.firstPhone ? "Inserire telefono" : undefined}
                        onChangeText={(text) => { dispatch(setFirstPhone(text)) }}
                    />
                    <MadfarmInput label={'Cellulare 2'} placeholder='Cellulare 2' value={anagraficaState.createAnagraphicRequest.secondPhone} defaultValue={anagraficaState.createAnagraphicRequest.secondPhone} onChangeText={(text) => { dispatch(setSecondPhone(text)) }} />
                </div>
                <div className="grid grid-cols-3 gap-4">
                    <MadfarmInput
                        label={'Email'}
                        placeholder="Email"
                        value={anagraficaState.createAnagraphicRequest.firstEmail}
                        defaultValue={anagraficaState.createAnagraphicRequest.firstEmail}
                        error={anagraficaState.anagraphicErrors.firstEmail}
                        supportingText={anagraficaState.anagraphicErrors.surname ? "Inserire email" : undefined}
                        onChangeText={(text) => { dispatch(setFirstEmail(text)) }}
                    />
                    <MadfarmInput label={'Email 2'} placeholder='Email 2' value={anagraficaState.createAnagraphicRequest.secondEmail} defaultValue={anagraficaState.createAnagraphicRequest.secondEmail} onChangeText={(text) => { dispatch(setSecondEmail(text)) }} />
                    <MadfarmInput
                        label={'Pec'}
                        placeholder="Pec"
                        value={anagraficaState.createAnagraphicRequest.pec}
                        defaultValue={anagraficaState.createAnagraphicRequest.pec}
                        error={anagraficaState.anagraphicErrors.pec}
                        supportingText={anagraficaState.anagraphicErrors.pec ? "Inserire pec" : undefined}
                        onChangeText={(text) => { dispatch(setPec(text)) }}
                    />
                </div>
            </CustomAccordion>

            <CustomAccordion
                id="panel5"
                title={<span className="text-uppercase text-white label-input">Dati fiscali</span>}
                expanded={expanded === 'panel5'}
                onChange={() => handleToggleAccordion('panel5')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-1 gap-4">
                    <MadfarmInput
                        label={'Codice fiscale'}
                        placeholder="Codice fiscale"
                        value={anagraficaState.createAnagraphicRequest.fiscalCode}
                        defaultValue={anagraficaState.createAnagraphicRequest.fiscalCode}
                        error={anagraficaState.anagraphicErrors.fiscalCode}
                        supportingText={anagraficaState.anagraphicErrors.fiscalCode ? "Inserire cod. fiscale" : undefined}
                        onChangeText={(text) => { dispatch(setFiscalCode(text)) }}
                    />
                </div>

                <div className="grid grid-cols-3 gap-4">
                    <MadfarmInput label={'Partita Iva'} placeholder="Partita Iva" defaultValue={anagraficaState.createAnagraphicRequest.vat} onChangeText={(text) => { dispatch(setVat(text)) }} />
                    <MadfarmInput label={'Codice destinatario (SDI)'} placeholder='Codice destinatario (SDI)' value={anagraficaState.createAnagraphicRequest.sdi} defaultValue={anagraficaState.createAnagraphicRequest.sdi} onChangeText={(text) => { dispatch(setSdi(text)) }} />
                    <MadfarmStaticSelect
                        label="Regime fiscale"
                        placeholder={'Regime fiscale'}
                        options={fiscalRegimeOptions}
                        value={String(anagraficaState.createAnagraphicRequest.fiscalRegime)}
                        defaultValue={String(anagraficaState.createAnagraphicRequest.fiscalRegime)}
                        error={anagraficaState.anagraphicErrors.fiscalRegime}
                        errorLabel="Inserire regime fiscale"
                        noOptionsMessage="Nessun regime fiscale trovato"
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setFiscalRegime(selectToValue(newValue)))
                        }}
                    />
                </div>
            </CustomAccordion>

            <CustomAccordion
                id="panel6"
                title={<span className="text-uppercase text-white label-input">Iscrizione al collegio o ordine professionale</span>}
                expanded={expanded === 'panel6'}
                onChange={() => handleToggleAccordion('panel6')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-3 gap-4">
                    <MadfarmInput label={'Albo professionale'} placeholder="Albo professionale" value={anagraficaState.createAnagraphicRequest.professionalRegister} defaultValue={anagraficaState.createAnagraphicRequest.professionalRegister} onChangeText={(text) => { dispatch(setProfessionalRegister(text)) }} />
                    <MadfarmInput label={'Comune'} placeholder='Comune' value={anagraficaState.createAnagraphicRequest.cityRegister} defaultValue={anagraficaState.createAnagraphicRequest.cityRegister} onChangeText={(text) => { dispatch(setCityRegister(text)) }} />
                    <MadfarmInput label={'N° di registro'} placeholder='N° di registro' value={anagraficaState.createAnagraphicRequest.numRegister} defaultValue={anagraficaState.createAnagraphicRequest.numRegister} onChangeText={(text) => { dispatch(setNumRegister(text)) }} />
                </div>
            </CustomAccordion>

            <CustomAccordion
                id="panel7"
                title={<span className="text-uppercase text-white label-input">Altri dati</span>}
                expanded={expanded === 'panel7'}
                onChange={() => handleToggleAccordion('panel7')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-2 gap-4">
                    <Calendar
                        label="Data ingresso"
                        selected={anagraficaState.createAnagraphicRequest.starting}
                        onChange={(date) => {
                            dispatch(setStarting(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                    <Calendar
                        label="Data uscita"
                        selected={anagraficaState.createAnagraphicRequest.ending}
                        onClear={(date) => dispatch(setEnding(date))}
                        onChange={(date) => {
                            dispatch(setEnding(format(new Date(date), 'yyyy-MM-dd')))
                        }}
                    />
                </div>

                <TextArea
                    label="Note"
                    placeholder="Testo segnaposto nota aggiuntiva"
                    onChangeText={(text) => dispatch(setNote(text))}
                />
            </CustomAccordion>
        </div>
    )
}
